import styled from 'styled-components';
import {
  Select,
  StrictOption,
} from '../../../../../components/Toolkit/Inputs/Select';
import { Label } from '../../../../../components/Toolkit/Inputs/Label';
import { mapOptionsRanges } from '../../../../../components/DealerPage/mappers/filters';

type DropDownValue = {
  options: StrictOption[];
  selectedValue: string;
};

export interface IDropDownRange {
  label: string;
  name: string;
  from: DropDownValue;
  to: DropDownValue;
  onFromChange: (from: string) => void;
  onToChange: (to: string) => void;
}

export const DropDownRangeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  select {
    margin-bottom: ${({ theme }) => theme.spacing.S4};
  }

  div:first-child {
    > select {
      border-right: 1px solid ${({ theme }) => theme.donedeal.colors.GREY};

      border-radius: ${({ theme }) =>
        `${theme.borderRadius.m} 0 0 ${theme.borderRadius.m}`};
    }
  }

  div:last-child {
    > select {
      border-left: 0;
      border-radius: ${({ theme }) =>
        `0 ${theme.borderRadius.m} ${theme.borderRadius.m} 0`};
    }
  }
`;

function DropDownRange({
  label,
  name,
  from,
  to,
  onFromChange,
  onToChange,
}: IDropDownRange) {
  return (
    <div>
      <Label htmlFor="search-price-filter-for">{label}</Label>
      <DropDownRangeContainer>
        <Select
          onChange={onFromChange}
          name={`from-${name}`}
          value={from.selectedValue}
          options={from.options}
        />
        <Select
          onChange={onToChange}
          name={`to-${name}`}
          value={to.selectedValue}
          options={mapOptionsRanges(from, to)}
        />
      </DropDownRangeContainer>
    </div>
  );
}

export { DropDownRange };
